<template>
  <v-dialog v-model="dialog" width="90%">
    <v-card elevation="3">

      <div class="pp-sidenav">
        <v-card-title class="white--text">
          Publish a Review
        </v-card-title>

        <v-card-subtitle class="white--text">
          Add details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs dark
              width="250"
              color="primary"
              vertical>
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-plus
          </v-icon>
          Review Details
        </v-tab>

        <v-tab-item>
          <v-card flat>
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Add Review Details
                  </v-card-title>

                  <div class="py-5 pa-3">
                    <v-card-text>
                      <v-row>
                        <v-text-field
                            v-model="add.title"
                            aria-required="true"
                            color="primary"
                            label="Review Title"
                            placeholder="Add a Review Title"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>
                      <v-row v-if="reviewApiError && reviewApiError.fields && reviewApiError.fields.title" class="err-text">
                        <p class="error--text">
                          Review title should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row>
                        <v-text-field
                            v-model="add.author"
                            hint="The author will be publicly visible"
                            persistent-hint
                            label="Author"
                            class="mb-5"
                            aria-required="true"
                            color="primary"
                            placeholder="Add a Review Author"
                            prepend-icon="mdi-account-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>

                      <v-row v-if="reviewApiError && reviewApiError.fields && reviewApiError.fields.author" class="err-text">
                        <p class="error--text">
                          Review author should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row>
                        <v-textarea
                            v-model="add.review"
                            auto-grow
                            hint="The review will be publicly visible"
                            persistent-hint
                            label="Review"
                            class="mb-5"
                            aria-required="true"
                            color="primary"
                            placeholder="Add a Review Description"
                            prepend-icon="mdi-format-line-style"
                            flat
                            solo
                            clearable
                        ></v-textarea>
                      </v-row>

                      <v-row v-if="reviewApiError && reviewApiError.fields && reviewApiError.fields.review" class="err-text">
                        <p class="error--text">
                          Review should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <ImagePicker v-model="add.image"/>

                      <TagsInput
                          v-model="add.tags"
                          :validationError="reviewApiError"
                      />

                      <v-row v-if="reviewApiError">
                        <v-alert
                            text
                            color="red"
                            icon="mdi-alert-circle-outline"
                        >
                          There was an error in submission. Please check all fields and try again.
                        </v-alert>
                      </v-row>
                    </v-card-text>
                  </div>
                </v-card>
              </template>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->
      <div class="pp-sidenav">
        <div class="btm">

          <Loading v-if="reviewItemLoading" />

          <ConfirmCancelButtons
              :item="add"
              confirm-text="Create Review"
              :confirm-action="addItemConfirm"
              :cancel-action="closeDialog"
              :confirm-disabled="reviewItemLoading"/>
        </div>
      </div>
      <!-- ------------------------------------------end of buttons ------------------------------------------ -->
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import ImagePicker from "@/components/common/ImagePicker";
import Loading from "@/components/common/Loading";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "ReviewAdd",
  components: {
    TagsInput, Loading, ImagePicker, ConfirmCancelButtons,
  },
  data() {
    return {
      add: {
        title: '',
        author: '',
        review: '',
        image: undefined,
        tags: [],
      },
    };
  },
  computed: {
    ...mapGetters(['reviewApiError', 'openDialog', 'reviewItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'reviewAdd';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['addReview', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.reset();
    },
    async addItemConfirm() {
      const added = await this.addReview(this.add);

      if (added) {
        this.reset();
      }
    },
    reset() {
      this.closeOpenDialog();
      this.add = {
        title: '',
        author: '',
        review: '',
        tags: [],
      };
    },
  },
};
</script>
